import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';

//DSS Documentation on SocoConfigurationService - http://tiny.sc/cgsococonfigurationservice
import { SocoConfigurationService } from '@soco/configuration';


@Injectable({
    providedIn: 'root'
})
export class AuthorizationService {
    roles: any = null;
    private rolesUpdatedSource = new ReplaySubject<string[]>();
    rolesUpdated = this.rolesUpdatedSource.asObservable();

    constructor(
        private config: SocoConfigurationService
    ) { }

    isSystemAdmin(): Observable<boolean> {
        return this.isInRole('SystemAdmin');
    }

    isSampleAdmin(): Observable<boolean> {
        return this.isInRole('SampleAdmin');
    }

    isSampleViewer(): Observable<boolean> {
        return this.isInRole('SampleViewer');
    }

    isInRole(roleName: string): Observable<boolean> {
        return this.getCurrentUsersRoles().pipe(map(roles => {
            return roles.indexOf(roleName) > -1;
        }));
    }

    getCurrentUsersRoles(): Observable<string[]> {
        // check if we've already retrieved the current user's roles, if so return them
        if (this.roles) {
            this.rolesUpdatedSource.next(this.roles);
            return this.rolesUpdated;
        }

        // retrieve the roles from configuration
        let rolesSettingName = 'Roles';
        this.config.getSetting<string[]>(rolesSettingName).subscribe(roles => {
            this.roles = roles;
            this.rolesUpdatedSource.next(this.roles);
        });

        //return an observable that we'll update once we retrieve the user's roles and verify if they have 
        //any of the required roles for this route
        return this.rolesUpdated;
    }
}

